// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1K43e","emails":"CreateEditClinics_emails__ZihNH","emailTagLabel":"CreateEditClinics_emailTagLabel__1l4Rd"};